import _styled from "@emotion/styled/base";
import { Colors } from '../..';
const {
  plum_electric,
  plum_dark,
  sec_green,
  grey_lighter
} = Colors;
const colorPalette = {
  blue: plum_electric,
  purple: plum_dark,
  green: sec_green,
  grey: grey_lighter
};
const setSize = size => {
  switch (size) {
    case 'small':
      return '32px';
    case 'medium':
      return '40px';
    case 'large':
      return '60px';
    default:
      return '40px';
  }
};
export const SpinnerWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1q0bhlx0"
} : {
  target: "e1q0bhlx0",
  label: "SpinnerWrapper"
})("display:flex;.MuiCircularProgress-root{&.MuiCircularProgress-colorPrimary{&.MuiCircularProgress-indeterminate{color:", _ref => {
  let {
    color
  } = _ref;
  return colorPalette[color];
}, ";width:", props => setSize(props.size), ";height:", props => setSize(props.size), ";}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9BdG9tcy9TcGlubmVyL1NwaW5uZXIuc3R5bGVzLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4QndDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9BdG9tcy9TcGlubmVyL1NwaW5uZXIuc3R5bGVzLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbG9ycyB9IGZyb20gJy4uLy4uJztcblxuY29uc3Qge1xuICBwbHVtX2VsZWN0cmljLFxuICBwbHVtX2RhcmssXG4gIHNlY19ncmVlbixcbiAgZ3JleV9saWdodGVyXG59ID0gQ29sb3JzO1xuXG5jb25zdCBjb2xvclBhbGV0dGUgPSB7XG4gIGJsdWU6IHBsdW1fZWxlY3RyaWMsXG4gIHB1cnBsZTogcGx1bV9kYXJrLFxuICBncmVlbjogc2VjX2dyZWVuLFxuICBncmV5OiBncmV5X2xpZ2h0ZXJcbn07XG5cbmNvbnN0IHNldFNpemUgPSAoc2l6ZSkgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzbWFsbCc6XG4gICAgICByZXR1cm4gJzMycHgnO1xuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgICByZXR1cm4gJzQwcHgnO1xuICAgIGNhc2UgJ2xhcmdlJzpcbiAgICAgIHJldHVybiAnNjBweCc7XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAnNDBweCc7XG4gIH1cbn07XG5cbmV4cG9ydCBjb25zdCBTcGlubmVyV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5cbiAgLk11aUNpcmN1bGFyUHJvZ3Jlc3Mtcm9vdCB7XG4gICAgJi5NdWlDaXJjdWxhclByb2dyZXNzLWNvbG9yUHJpbWFyeSB7XG4gICAgICAmLk11aUNpcmN1bGFyUHJvZ3Jlc3MtaW5kZXRlcm1pbmF0ZSB7XG4gICAgICAgIGNvbG9yOiAkeyh7IGNvbG9yIH0pID0+IGNvbG9yUGFsZXR0ZVtjb2xvcl19O1xuICAgICAgICB3aWR0aDogJHsocHJvcHMpID0+IHNldFNpemUocHJvcHMuc2l6ZSl9O1xuICAgICAgICBoZWlnaHQ6ICR7KHByb3BzKSA9PiBzZXRTaXplKHByb3BzLnNpemUpfTtcblxuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ== */"));